import React, { useState } from 'react'
import { Card, CardMedia, CardContent, makeStyles, Typography, Collapse, CardActions, Button, Dialog, DialogContent, DialogContentText, DialogActions } from '@material-ui/core'
import { alpha } from '@material-ui/core/styles/colorManipulator'
import InviteButton from 'components/InviteButton'
import formatCurrency from 'utils/formatCurrency'
import PropTypes from 'prop-types'

const useStyles = makeStyles(({ palette }) => {
  return ({
    main: ({ narrow }) => narrow ? ({
      position: 'relative'
    }) : ({
      display: 'flex'
    }),
    // 4:3 aspect ratio
    media: ({ narrow }) => narrow ? ({
      paddingTop: '75%'
    }) : ({
      paddingTop: '37.5%',
      width: '50%'
    }),
    details: ({ narrow }) => narrow ? ({
      width: '100%',
      color: palette.common.white,
      left: 0,
      bottom: 0,
      position: 'absolute',
      backgroundColor: alpha(palette.grey[900], 0.6)
    }) : ({
      width: '50%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }),
    content: ({ narrow }) => narrow && ({
      paddingBottom: 0
    })
  })
})

export default function CommunityCard({ name, imageUrl, description, donationTotal, memberCount, narrowView }) {
  const [showDescription, setShowDescription] = useState(false)
  const classes = useStyles({ narrow: narrowView })
  function toggleDescription() {
    setShowDescription(!showDescription)
  }

  return (
    <Card>
      <div className={classes.main}>
        <CardMedia className={classes.media} image={imageUrl} />
        <div className={classes.details}>
          <CardContent className={classes.content}>
            <Typography variant='h6' component='h1'>{name}</Typography>
            <Typography variant='subtitle2'>{memberCount} member{memberCount > 1 && 's'}</Typography>
            <Typography variant='body2'>{formatCurrency(donationTotal)} given</Typography>
          </CardContent>

          <CardActions>
            <InviteButton color='secondary' variant='contained' />
            <Button onClick={toggleDescription} color='secondary'>
              {showDescription ? 'hide description' : 'show description'}
            </Button>
          </CardActions>
        </div>
      </div>

      {narrowView ? (
        <Collapse in={showDescription}>
          <CardContent>
            <Typography paragraph>{description}</Typography>
          </CardContent>
        </Collapse>
      ) : (
        <Dialog maxWidth='sm' fullWidth open={showDescription} onClose={() => setShowDescription(false)}>
          <DialogContent>
            <DialogContentText>
              {description}
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setShowDescription(false)}>close</Button>
          </DialogActions>
        </Dialog>
      )}
    </Card>
  )
}

CommunityCard.propTypes = {
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  donationTotal: PropTypes.string.isRequired,
  memberCount: PropTypes.number.isRequired,
  narrowView: PropTypes.bool.isRequired
}
